import { Routes } from '@angular/router';
import { EnhancedAuthGuard } from 'src/app/core/guards/enhanced-auth.guard';
import { RouteData } from 'src/app/core/models/route-data';

/** Reporting and reports hub routes. */
export const REPORTING_ROUTES: Routes = [
    {
        path: 'reports',
        loadComponent: () => import('src/components/reports/reports.component').then(m => m.ReportsComponent),
        canActivate: [EnhancedAuthGuard],
        data: {
            permissionKey: 'reports',
            requiresPermission: true
        } satisfies RouteData
    },

    {
        path: 'reports/registrations-dashboard',
        loadComponent: () => import('src/components/reports/registrations-dashboard/registrations-dashboard.component').then(m => m.RegistrationsDashboardComponent),
        canActivate: [EnhancedAuthGuard],
        data: {
            permissionKey: 'reportsRegistrationsDashboard',
            // Firm-specific article ID 44 existed in pre-FOF-7854 determineHelpPathForFirm(), which
            // was never called — removed (no advisors ID exists for this route). See FOF-7854.
            requiresPermission: true
        } satisfies RouteData
    },

    {
        path: 'reporting',
        loadComponent: () => import('src/components/reporting/reporting.component').then(m => m.ReportingComponent),
        canActivate: [EnhancedAuthGuard],
        data: {
            permissionKey: 'reporting',
            requiresPermission: true
        } satisfies RouteData
    },

    {
        path: 'reporting/interactive',
        loadComponent: () => import('src/components/reporting/interactive-reports/interactive-reports.component').then(m => m.InteractiveReportsComponent),
        canActivate: [EnhancedAuthGuard],
        data: {
            permissionKey: 'reportingInteractive',
            requiresPermission: true
        } satisfies RouteData
    },

    {
        path: 'reporting/standard',
        loadComponent: () => import('src/components/reporting/standard/standard-reports/standard-reports.component').then(m => m.StandardReportsComponent),
        canActivate: [EnhancedAuthGuard],
        data: {
            permissionKey: 'reportingStandard',
            requiresPermission: true
        } satisfies RouteData
    },

    {
        path: 'reporting/pentaho',
        loadComponent: () => import('src/app/multi-outlet-container.component').then(m => m.MultiOutletContainerComponent),
        canActivate: [EnhancedAuthGuard],
        data: {
            permissionKey: 'reportingPentaho',
            requiresPermission: true
        } satisfies RouteData,
        children: [
            {
                path: '',
                loadComponent: () => import('src/components/reporting/pentaho/pentaho.component').then(m => m.PentahoComponent),
                outlet: 'content'
            },
            {
                path: '',
                loadComponent: () => import('src/app/empty.component').then(m => m.EmptyComponent),
                outlet: 'sideRail'
            }
        ]
    }
];
